import {
  ButtonLink,
  ButtonRouterLink,
  Card,
  MonoLabel,
  SectionCrosshairs,
  SectionHead,
  Tag
} from '../../components/primitives';
import {
  formatTierSeatLabel,
  PUBLIC_TIER_CATALOG,
  TIER_DISPLAY_NAME,
  type PublicTierPlan
} from '../../lib/subscriptionTiers';

function PricingCard({ plan }: { plan: PublicTierPlan }) {
  const isFree = plan.tier === 'free';
  const priceLabel = isFree ? '$0' : `$${plan.monthlyPriceUsd}`;

  return (
    <Card
      className={[
        'lp-pricing-card',
        plan.highlighted ? 'lp-pricing-card-hi' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      data-tier={plan.tier}
      data-testid={`landing-pricing-${plan.tier}`}
    >
      <header className="lp-pricing-card-head">
        <h3 className="lp-pricing-card-name">{TIER_DISPLAY_NAME[plan.tier]}</h3>
        {plan.highlighted ? (
          <Tag className="lp-pricing-card-tag">Popular</Tag>
        ) : null}
      </header>
      <div className="lp-pricing-card-price">
        <span className="lp-pricing-card-price-amount tnum">{priceLabel}</span>
        <MonoLabel size="sm" tracking="wide" tone="muted">
          /mo
        </MonoLabel>
      </div>
      <MonoLabel
        size="sm"
        tracking="wide"
        tone="muted"
        as="div"
        className="lp-pricing-card-seats"
      >
        {formatTierSeatLabel(plan.maxSeats)}
      </MonoLabel>
      <p className="lp-pricing-card-summary">{plan.summary}</p>
      <div className="lp-pricing-card-cta">
        <ButtonRouterLink
          to="/sign-up"
          variant={plan.highlighted || isFree ? 'primary' : 'default'}
          size="md"
        >
          {isFree ? 'Start free' : 'Get started'}
        </ButtonRouterLink>
      </div>
    </Card>
  );
}

export function LandingPricing() {
  return (
    <section className="pn-section" id="pricing">
      <div className="pn-page">
        <SectionCrosshairs />
        <SectionHead
          marker="§ 07"
          title="Simple monthly pricing."
          tag="USD · per org"
        />

        <div className="lp-pricing-grid">
          {PUBLIC_TIER_CATALOG.map((plan) => (
            <PricingCard key={plan.tier} plan={plan} />
          ))}
        </div>

        <div className="lp-pricing-foot">
          <div className="lp-pricing-foot-copy">
            <h3 className="lp-pricing-foot-h">
              Put your team and their agents on the <em>same page</em>.
            </h3>
            <p className="lp-pricing-foot-lede">
              All plans include Penrose IDE + web, role-aware MCP, documents,
              work items, and agent rules. Upgrade anytime from Settings →
              Billing after you sign up.
            </p>
          </div>
          <div className="lp-pricing-foot-actions">
            <div className="lp-pricing-foot-row">
              <ButtonLink href="#partner" size="lg">
                Design partner →
              </ButtonLink>
              <ButtonRouterLink to="/sign-up" variant="primary" size="lg">
                Start free
              </ButtonRouterLink>
            </div>
            <MonoLabel size="md" tracking="wide">
              // IDE + web · day one
            </MonoLabel>
          </div>
        </div>
      </div>
    </section>
  );
}
